import { Injectable, inject } from '@angular/core';
import { ActiveCompanyService } from './active-company.service';
import { ModuleAccessService } from './module-access.service';
import { AuditUserDirectoryService } from './audit-user-directory.service';
import { ApiService } from './api.service';
import { VersionService } from '../app/core/services/version.service';
import { clearAllVersionRefs } from '../utils/version-tracking.util';

/**
 * Clears client-side session caches on logout/login boundaries so no prior
 * user, company, branch, or permission state survives into a new session.
 */
@Injectable({ providedIn: 'root' })
export class SessionCleanupService {
  private readonly activeCompany = inject(ActiveCompanyService);
  private readonly moduleAccess = inject(ModuleAccessService);
  private readonly auditUserDirectory = inject(AuditUserDirectoryService);
  private readonly api = inject(ApiService);
  private readonly version = inject(VersionService);

  /** Full session reset on logout or auth failure. */
  clearSessionState(clearCredentials = false): void {
    void clearCredentials;
    this.activeCompany.resetSessionState();
    this.moduleAccess.resetSessionState();
    this.auditUserDirectory.clear();
    this.api.clearSessionState();
    this.version.invalidateCache();
    clearAllVersionRefs();
  }

  /** Prepare for a new login — discard stale in-memory state before loading fresh data. */
  prepareForLogin(): void {
    this.clearSessionState(false);
  }
}
